export default {
  LIST_ITEM: 'listItem',
}



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/responseMessage/components/ItemTypes.js